export default "__VITE_ASSET__6e4449f0__"